export const getDirectLink = ({
  uuid = '',
  responseURI = '',
  env
}: {
  uuid: UUID;
  responseURI?: string;
  env: ServerEnvironment;
}): string => {
  let queryString = `?uuid=${uuid}`;
  if (responseURI) {
    queryString += `&redirect_url=${responseURI}`;
  }

  if (env === 'prod') {
    return `https://jump.nect.app/${queryString}`;
  }
  if (env === 'dev') {
    return `https://jump.dev.svc.nect.app/${queryString}`;
  }
  return `https://test.jump.nect.app/${queryString}`;
};
